/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState, useContext} from 'react';
import Media from '../Media/Media';
import {Badge} from '..';
import {ARMcontext} from '../../utils/context/context';
import {
  TableBasic,
  ShadowTableColumn,
  StickyTableHeadList,
  ArrowHolderSummary,
  ColumnContainer,
  MediaBadge,
  MediaBadgeText,
} from './styles';
import Utils from '../../utils/api/Utils';
import {GoChevronDown, GoChevronUp} from 'react-icons/go';
import { useNavigate } from 'react-router-dom';
export default ({dataTableContent, dataCy, minWidth}: {dataCy?: string; dataTableContent: Array<any>; minWidth: string}) => {
  const {HandleSelectedTeam} = useContext(ARMcontext);
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(true);
  const UTILS = new Utils();
  const navigate = useNavigate();
  const sortOptions = [!reverse, changeTable, table];

  useEffect(() => {
    useTable(dataTableContent);
  }, [dataTableContent]);

  function changeTable(e) {
    useTable([...e]);
  }
  function handleCard(selectedTeam: any | object): void {
    HandleSelectedTeam(selectedTeam);
    navigate('/players/dashboard');
  }

  function toggleSortString(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }
  function toggleSortNumber(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.HandleSorted(params, sortOptions);
  }

  function sortingTableHead(title: string = '', attr: string, location: Array<string>, sortFunction) {
    return (
      <StickyTableHeadList topPosition="0px" onClick={() => sortFunction(attr, location)}>
        <ColumnContainer>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainer>
      </StickyTableHeadList>
    );
  }

  return (
    <TableBasic data-cy={dataCy} minWidth={minWidth}>
      <thead>
        <tr>
          {sortingTableHead('TEAM/GROUP', 'team', ['name'], toggleSortString)}
          {sortingTableHead('TOTAL PLAYERS', 'totalPlayers', ['totalPlayers'], toggleSortNumber)}
          {sortingTableHead('PITCHERS', 'pitchers', ['pitchers'], toggleSortNumber)}
          {sortingTableHead('CATCHERS', 'catchers', ['catchers'], toggleSortNumber)}
          {sortingTableHead('INFIELDERS', 'infielders', ['infielders'], toggleSortNumber)}
          {sortingTableHead('OUTFIELDERS', 'outfielders', ['outfielders'], toggleSortNumber)}
        </tr>
      </thead>
      <tbody onClick={() => useSort('')}>
        {table?.length > 0 ? (
          table?.map((item, index) => {
            return (
              <tr key={index}>
                <td onClick={() => handleCard(item)} style={{cursor: 'pointer'}}>
                  <MediaBadge>
                    {item.picture && item.name !== 'All Players' ? (
                      <Media imgUrl={item.picture} size="33px" mRight="0px" />
                    ) : item.badge === 'ALL' ? (
                      <Badge color="#007AFF" size={'32px'} font={'16px'} />
                    ) : (
                      <Badge text={item?.badge || item.initials} color={item?.color} size={'32px'} font={'16px'} />
                    )}
                    <MediaBadgeText>{item.name}</MediaBadgeText>
                  </MediaBadge>
                </td>
                <td>{item.totalPlayers}</td>
                <td>{item.pitchers}</td>
                <td>{item.catchers}</td>
                <td>{item.infielders}</td>
                <ShadowTableColumn>{item.outfielders}</ShadowTableColumn>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan={6}>No Data</td>
          </tr>
        )}
      </tbody>
    </TableBasic>
  );
};
